<template>
  <div :class="`card ${ disabled ? disabled_class : ''}`"
       @mouseover="visible = true"
       @mouseleave="visible = false">
    <img :src="image" />
    <div v-if="visible && disabled" class="disabledHover" ref="hoverDiv">
      <svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44.89">
        <title>skanzen_soon_icon</title>
        <polyline class="cls-1" points="26 25.89 22 21.89 22 12.89"/>
        <path class="cls-1" d="M137,72a15,15,0,1,0,30,0,15.38,15.38,0,0,0-4.37-11.46,15,15,0,0,0-21.22-.15l-2.5,2.5L141,65v1H131V56h1l2.67,2.67,2.48-2.45a21,21,0,0,1,29.7.08A20.65,20.65,0,0,1,173,72h0a21,21,0,0,1-21,21" transform="translate(-130 -49.11)"/>
      </svg>
      <h2>
        Ez a Tartalom hamarosan elérhető!
      </h2>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeCard',
  props: ['image', 'disabled_class', 'disabled'],
  data() {
    return {
      visible: false,
    };
  },
};
</script>

<style scoped>

</style>
